module.exports = __webpack_public_path__ + "img/guest_man.c24c1fc6.png";